// Most-recently-used decline reasons, per dashboard user.
// Stored in localStorage so the list is per-device but persists across sessions.
// Keyed by username so different operators see their own most-used reasons.

const STORAGE_PREFIX = 'sqp.mru.declineReasons.';
const MAX_REASONS = 5;

function storageKey(username) {
  return STORAGE_PREFIX + (username || 'anon');
}

export function getMruReasons(username) {
  try {
    const raw = localStorage.getItem(storageKey(username));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter(r => typeof r === 'string' && r.trim()) : [];
  } catch (_) { return []; }
}

export function pushMruReason(username, reason) {
  const trimmed = (reason || '').trim();
  if (!trimmed) return;
  const current = getMruReasons(username);
  // Remove case-insensitive duplicates, then push to front.
  const filtered = current.filter(r => r.toLowerCase() !== trimmed.toLowerCase());
  const next = [trimmed, ...filtered].slice(0, MAX_REASONS);
  try { localStorage.setItem(storageKey(username), JSON.stringify(next)); } catch (_) {}
}
